export const normalizeSearchText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const getGuideSearchText = (guide) =>
  normalizeSearchText(
    [
      guide.title,
      guide.summary,
      guide.latestLabel,
      guide.latestSummary,
      guide.category,
      ...(guide.tags || []),
      ...(guide.keywords || []),
      ...(guide.steps || []).flatMap((step) => [step.title, step.body]),
    ].join(" ")
  );

export const searchHelpGuides = (guides, query) => {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return guides;

  const terms = normalizedQuery.split(/\s+/).filter(Boolean);
  return guides.filter((guide) => {
    const searchText = getGuideSearchText(guide);
    return terms.every((term) => searchText.includes(term));
  });
};

export const sortGuidesByVisitCount = (guides, visitCounts = {}) =>
  [...guides].sort((a, b) => (visitCounts[b.id] || 0) - (visitCounts[a.id] || 0));

export const getGuidesByIds = (guides, ids = []) => {
  const byId = new Map(guides.map((guide) => [guide.id, guide]));
  return ids.map((id) => byId.get(id)).filter(Boolean);
};

export const sortGuidesForLanding = (guides) =>
  [...guides].sort((a, b) => {
    const priorityDifference = (a.landingPriority || 999) - (b.landingPriority || 999);
    if (priorityDifference !== 0) return priorityDifference;

    return String(b.updatedAt || "").localeCompare(String(a.updatedAt || ""));
  });

export const groupGuidesByCategory = (guides) =>
  guides.reduce((groups, guide) => {
    const category = guide.category || "Other";

    return {
      ...groups,
      [category]: [...(groups[category] || []), guide],
    };
  }, {});
